





import { Vue, Component } from "vue-property-decorator";
import { Currency, Locale } from "@lib";
import { Formatter } from "@/utils/formatter";

@Component({ name: "CellRendererMoney" })
export default class CellRendererMoney extends Vue {
    private params: any;

    private get customValue(): number {
        return this.params.modify ? this.params.modify(this.params.value) : this.params.value;
    }

    private get currency(): Currency | undefined {
        return this.params.currency;
    }

    private get locale(): Locale | undefined {
        return this.params.locale;
    }

    private get customClass(): string {
        return this.params.class ?? "";
    }

    public formatMoney(value: number): string {
        return Formatter.money(value, { locale: this.locale, currency: this.currency });
    }
}
